import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { Icon } from "../../components/Component";
import { getQuestionCountsAPI } from "../../api/question";
import useLogout from "../../Hooks/Logout";

import "./question-counts-cards.scss";

const DEFAULT_COUNTS = {
  total_questions: 0,
  pending_questions: 0,
  unanswered_questions: 0,
  rejected_questions: 0,
};

const cardsConfig = [
  {
    key: "total_questions",
    title: "Total questions",
    hint: "Catalogue size",
    icon: "file-docs",
    color: "#2a3091",
    to: "/question/approved-questions",
  },
  {
    key: "pending_questions",
    title: "Pending",
    hint: "Awaiting review",
    icon: "alert-circle-fill",
    color: "#c45c26",
    to: "/question/requested-questions",
  },
  {
    key: "unanswered_questions",
    title: "Unanswered",
    hint: "Fallback responses",
    icon: "help-fill",
    color: "#0f5c4f",
    to: "/unanswered-questions",
  },
  {
    key: "rejected_questions",
    title: "Rejected",
    hint: "Not published",
    icon: "cross-circle",
    color: "#6b2d5c",
    to: "/question/rejected-questions",
  },
];

const QuestionCountsCards = ({ className }) => {
  const [counts, setCounts] = useState(DEFAULT_COUNTS);
  const [loading, setLoading] = useState(true);
  const logout = useLogout();

  useEffect(() => {
    setLoading(true);
    getQuestionCountsAPI()
      .then((res) => {
        const s = res?.data?.status;
        if (s === true) {
          setCounts({ ...DEFAULT_COUNTS, ...(res.data.data || {}) });
        } else if (s === "expired") {
          logout(res?.data?.message);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [logout]);

  const cards = useMemo(() => {
    return cardsConfig.map((c) => ({
      ...c,
      value: Number(counts?.[c.key] ?? 0),
    }));
  }, [counts]);

  return (
    <div className={`question-counts-cards ${className || ""}`}>
      <Row className="g-gs">
        {cards.map((c) => (
          <Col key={c.key} xl="3" md="6">
            <Link to={c.to} className="question-counts-card text-reset d-block">
              <div className="question-counts-card__inner" style={{ backgroundColor: c.color }}>
                <div className="question-counts-card__top">
                  <div className="question-counts-card__icon" aria-hidden>
                    <Icon name={c.icon} />
                  </div>
                  <span className="question-counts-card__hint">{c.hint}</span>
                </div>
                <div className="question-counts-card__title">{c.title}</div>
                <div className="question-counts-card__value">{loading ? "…" : c.value}</div>
              </div>
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default QuestionCountsCards;

